import React from 'react';

import requireAuth from '~components/hocs/requireAuth';
import AdminTemplate from '../layout/AdminTemplate';
import CDNAnalytics from '~features/CDNAnalytics';

const META_TAGS = {
  title: 'CDN Analytics - Prerender.io',
};

function CDNAnalyticsPage() {
  return (
    <AdminTemplate metaTags={META_TAGS}>
      <CDNAnalytics />
    </AdminTemplate>
  );
}

export default requireAuth(CDNAnalyticsPage);
